import React, { useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import { Login, Register, SingleInputAuth } from "../../components";
import {verifyOtpEmailRegister} from "../../redux/actions/userActions";
const AuthForm = () => {
  const [success, setSuccess] = useState(false);
  const [userEmail, setUserEmail] = useState("")
  const getData = (success,userEmail) => {
    setSuccess(success);
    setUserEmail(userEmail);
    
  };
  return (
    <>
      {success ? (
        <SingleInputAuth
          tag={"input"}
          type={"text"}
          name={"otp"}
          placeholder={"Please enter your OTP here"}
          actionFunction={verifyOtpEmailRegister}
          userEmail={userEmail}
          
        />
      ) : (
        <div className="dg__account">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <Tab.Container defaultActiveKey="login">
                  <Nav
                    variant="pills"
                    className="acount__nav justify-content-center"
                  >
                    <Nav.Item>
                      <Nav.Link eventKey="login">Login</Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                      <Nav.Link eventKey="register">Register</Nav.Link>
                    </Nav.Item>
                  </Nav>
                  <Tab.Content>
                    <Tab.Pane eventKey="login">
                      <Login />
                    </Tab.Pane>
                    <Tab.Pane eventKey="register">
                      <Register getData={getData} />
                    </Tab.Pane>
                  </Tab.Content>
                </Tab.Container>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AuthForm;
